<div
  class="mobile-layout scroll-container bg-gradient"
  (scroll)="onContentScroll($event)"
>
  <!-- Region 1: Main Header (Sticky & Hides on Scroll) -->
  <header
    class="header-container bg-surface p-2 sm:p-6 md:p-8 border-b border-border"
    [class.header-hidden]="!headerVisible()"
  >
    <app-main-header [pageTitle]="pageContextService.pageTitle()" />
  </header>

  <!-- Region 2: Page Header (Sticky) -->
  <!-- <div
    class="page-header-container bg-gradient"
    [style.top]="headerVisible() ? '64px' : '0px'"
  >
    @if (pageContextService.pageTitle(); as title) {
    <app-page-header
      [title]="title"
      [subtitle]="pageContextService.pageSubtitle() || undefined"
      [actions]="pageContextService.actions()"
      [primaryAction]="pageContextService.fabAction()"
    />
    }
  </div> -->

  <!-- Region 3: Page Sub-Header (Sticky) -->
  @if (pageContextService.subHeaderContent(); as content) {
  <div
    class="page-sub-header-container bg-gradient"
    [style.top]="headerVisible() ? '64px' : '0px'"
  >
    <div class="sub-header-wrapper">
      @if (isTemplateRef(content)) {
      <ng-container [ngTemplateOutlet]="content"></ng-container>
      } @else {
      <ng-container
        [ngComponentOutlet]="content.component"
        [ngComponentOutletInputs]="content.inputs"
      >
      </ng-container>
      }
    </div>
  </div>
  }

  <!-- Region 4: Main Content -->
  <main class="main-content-container">
    <app-toast-stack />
    <router-outlet></router-outlet>
    @defer (when featureFlags.aiAssistantEligible()) {
      @if (featureFlags.aiAssistantEnabled()) {
        <app-assistant-widget />
      }
    }
  </main>

  <!-- Region 5: Floating Action Button -->
  <div class="fab-container">
    @if (pageContextService.fabAction(); as action) {
    <app-button
      (click)="pageContextService.emitAction(action.id)"
      [fab]="true"
      [icon]="action?.icon"
    ></app-button>
    }
  </div>

  <!-- Mobile Navigation Menu (Add this section) -->
  <app-mobile-nav-menu
    [isOpen]="layoutService.isMobileMenuOpen()"
    (closed)="layoutService.closeMobileMenu()"
  />
</div>

<!-- ADD: Add the sheet component to handle the aside on mobile -->
<app-sheet
  [isOpen]="!!asideService.asideContext()"
  (closed)="asideService.close()"
  [title]="asideService.asideContext()?.title || 'Details'"
  [headerAction]="asideService.headerAction()"
>
  <app-aside-content></app-aside-content>
</app-sheet>
